import React from "react";
import { CiSearch } from "react-icons/ci";
import logo from "../../../Assets/blogImg.png";
import ServicePage from "../ServicePage/Service.module.css";
import aboutus from "../../../Assets/Banner/blogbanner.svg";
import { NavLink } from "react-router-dom";

const Blog1 = () => {
  return (
    <div className={ServicePage.Services1_container}>
      <div className={ServicePage.Services1div1_container}>
        <h1 className={ServicePage.Services1text}>COMPANY BLOGS</h1>
        <p className={ServicePage.text_container}>
          <ul>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Home
              </NavLink>
            </li>
            <span>|</span>
            <li>
              <NavLink
                to="/services"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Company Blogs 
              </NavLink>
            </li>
          </ul>
        </p>
      </div>
      <div className={ServicePage.Services1image_container}>
        <img src={aboutus} alt="image" className={ServicePage.Services1Img} />
      </div>
    </div>
  );
};

export default Blog1;
